import { useCallback, useState } from 'react';

import { MenuToggleButton } from './MenuToggleButton';
import styles from './MobileHeader.module.scss';
import { MobileNavigation } from './MobileMenu/MobileNavigation';
import { AnnouncementBar } from '../AnnouncementBar/AnnouncementBar';
import { Branding } from '../Branding/Branding';
import { CtaButton } from '../CtaButton/CtaButton';

import type { HeaderData, HeaderMenuItem } from '../../types';

type MobileHeaderProps = {
  variant?: HeaderData['variant'];
  brand: HeaderData['brand'];
  announcement?: HeaderData['announcement'];
  menuItems: HeaderMenuItem[];
  cta: { label: string; url: string } | null;
};

export function MobileHeader({
  variant = 'default',
  brand,
  announcement,
  menuItems,
  cta,
}: MobileHeaderProps) {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [headerNode, setHeaderNode] = useState<HTMLElement | null>(null);
  const navigationId = 'mobile-navigation';

  const toggleMenu = () => setIsNavOpen((prev) => !prev);
  const handleCloseMenu = () => setIsNavOpen(false);
  const handleHeaderRef = useCallback((node: HTMLElement | null) => {
    setHeaderNode(node);
  }, []);

  return (
    <header
      className={`${styles.header} interact-header interact-header--${variant}`}
      data-header-variant={variant}
      role="banner"
      ref={handleHeaderRef}
    >
      <AnnouncementBar announcement={announcement} />

      <div className={`${styles.container} interact-header__row`}>
        <Branding brand={brand} variant={variant} />

        <div className={styles.actions}>
          {cta && <CtaButton label={cta.label} url={cta.url} mobile />}

          <MenuToggleButton controlsId={navigationId} isOpen={isNavOpen} onToggle={toggleMenu} />
        </div>
      </div>

      <MobileNavigation
        id={navigationId}
        isOpen={isNavOpen}
        items={menuItems}
        onClose={handleCloseMenu}
        hasAnnouncement={Boolean(announcement)}
        container={headerNode}
      />
    </header>
  );
}
